import React from 'react';

export const WrapPageElement: React.ReactNode = ({ element }: { element: React.FCX }) => <>{element}</>;

export default WrapPageElement;
